import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import ReactDOM from "react-dom/client";
import {Provider} from "react-redux";

import store from "./redux/reducer/store";

import VisitScheduleApp from "./modules/visitSchedule/visitScheduleApp";
import AccessRightsApp from "./modules/accessRights/accessRightsApp";
import ProjectsApp from "./modules/projects/ProjectsApp";
import ContractsApp from "./modules/contracts/ContractsApp";
import RecruitingApp from "./modules/recruiting/RecruitingApp";
import EmployeesApp from "./modules/employees/EmployeesApp";
import UserReportsApp from "./modules/userReports/UserReportsApp";
import PrivateRoute from "./components/privateRoute/privateRoute";
import UnloadingsApp from "./modules/unloadings/unloadingsApp";
import EasyMerchApp from "./modules/easymerch/EasyMerchApp";
import CriteriaApp from "./modules/criteria/CriteriaApp";
import ChartsApp from "./modules/charts/charts";
import MapApp from "./modules/map/MapApp";
import TunderApp from "./modules/tunder/TunderApp";
import Login from "./pages/login/login";
import Page404App from "./modules/page404/Page404App";

import "./scss/index.scss";
import {AnalyticsTracker} from './analytics/analyticsTracker';
import ConsolidatedBudgetApp from "./modules/consolidatedbudget/ConsolidatedBudgetApp";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

const detectedBasename = window.location.pathname.startsWith("/react")
                         ? "/react"
                         : "/";

root.render(
    <Provider store={store}>
        <BrowserRouter basename={detectedBasename}>
            <AnalyticsTracker/>
            <Routes>
                <Route path="/" element={<Navigate to="/login"/>}/>
                <Route
                    path="/easymerch/*"
                    element={<PrivateRoute component={<EasyMerchApp/>}/>}
                />
                <Route
                    path="/tunder/*"
                    element={<PrivateRoute component={<TunderApp/>}/>}
                />
                <Route
                    path="/reports/*"
                    element={<PrivateRoute component={<UserReportsApp/>}/>}
                />
                <Route
                    path="/accessRights/*"
                    element={<PrivateRoute component={<AccessRightsApp/>}/>}
                />
                <Route
                    path="/projects/*"
                    element={<PrivateRoute component={<ProjectsApp/>}/>}
                />
                <Route
                    path="/recruiting/*"
                    element={<PrivateRoute component={<RecruitingApp/>}/>}
                />
                <Route
                    path="/visit-schedule/*"
                    element={<PrivateRoute component={<VisitScheduleApp/>}/>}
                />
                <Route
                    path="/unloadings/*"
                    element={<PrivateRoute component={<UnloadingsApp/>}/>}
                />
                <Route
                    path="/employees/*"
                    element={<PrivateRoute component={<EmployeesApp/>}/>}
                />
                <Route
                    path="/charts/*"
                    element={<PrivateRoute component={<ChartsApp/>}/>}
                />
                <Route
                    path="/map/*"
                    element={<PrivateRoute component={<MapApp/>}/>}
                />
                <Route
                    path="/contracts/*"
                    element={<PrivateRoute component={<ContractsApp/>}/>}
                />
                <Route
                    path="/consolidatedbudget/*"
                    element={<PrivateRoute component={<ConsolidatedBudgetApp/>}/>}
                />
                <Route
                    path="/criteria/*"
                    element={<PrivateRoute component={<CriteriaApp/>}/>}
                />
                <Route path="/login/*" element={<Login/>}/>
                <Route path="/page404/*" element={<Page404App/>}/>
            </Routes>
        </BrowserRouter>
    </Provider>
);
